"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Text4 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _InputField = _interopRequireDefault(require("@kiwicom/orbit-components/lib/InputField"));
var _useMediaQuery = _interopRequireDefault(require("@kiwicom/orbit-components/lib/hooks/useMediaQuery"));
var _Market = require("../../../../../records/Market");
var _SelectableTile = _interopRequireDefault(require("../SelectableTile"));
var _DropdownTile = _interopRequireDefault(require("../DropdownTile"));
var _Grid = _interopRequireDefault(require("../Grid"));
var _Search2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Search"));
var _jsxRuntime = require("react/jsx-runtime");
var _Text, _Text2, _Search, _Text3;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const isGlobalMarket = marketId => marketId === _Market.GLOBAL_MARKET_ID;
const LanguageSelect = _ref => {
  let {
    languageId,
    marketId: selectedMarketId,
    setMarket,
    markets
  } = _ref;
  const {
    isTablet
  } = (0, _useMediaQuery.default)();
  const intl = (0, _reactIntl.useIntl)();
  const isGlobalMarketSelected = isGlobalMarket(selectedMarketId);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [searchResults, setSearchResults] = React.useState(markets);
  const onSetMarket = _ref2 => {
    let {
      market,
      language
    } = _ref2;
    setMarket({
      marketId: market.id,
      languageId: language.id
    });
  };
  React.useEffect(() => {
    const filteredMarkets = Object.keys(markets).reduce((acc, marketKey) => {
      const market = markets[marketKey];
      if (market.name.toLowerCase().includes(searchQuery) || market.id.toLowerCase().includes(searchQuery) || market.languages.some(l => l.name.toLowerCase().includes(searchQuery))) {
        return {
          ...acc,
          [marketKey]: market
        };
      }
      return acc;
    }, {});
    setSearchResults(filteredMarkets);
  }, [markets, searchQuery]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
    direction: "column",
    spacing: "400",
    children: [_Text || (_Text = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text4.default, {
      size: "large",
      type: "secondary",
      weight: "medium",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.market_settings_modal.suggested_language_region"
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
      children: Object.keys(markets[selectedMarketId].languages).map(l => {
        const market = markets[selectedMarketId];
        const language = market.languages[l];
        const {
          id,
          name
        } = language;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectableTile.default, {
          dataTest: "region-tile",
          title: market.name,
          flag: isGlobalMarket(market.id) ? "" : market.flag,
          options: name,
          selected: selectedMarketId === market.id && languageId === id,
          onSelect: () => onSetMarket({
            market,
            language
          })
        }, id);
      })
    }), _Text2 || (_Text2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text4.default, {
      size: "large",
      type: "secondary",
      weight: "medium",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.market_settings_modal.choose_language_region"
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
      children: [!isTablet && /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputField.default, {
        type: "text",
        placeholder: intl.formatMessage({
          id: "account.market_settings_modal.search"
        }),
        prefix: _Search || (_Search = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Search2.default, {
          size: "small"
        })),
        value: searchQuery,
        onChange: e => {
          setSearchQuery(e.currentTarget.value);
        }
      }), Object.keys(searchResults).map(marketId => {
        if (isGlobalMarket(marketId)) {
          return null;
        }
        const {
          id,
          languages,
          flag,
          name
        } = searchResults[marketId];
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownTile.default, {
          flag: flag,
          selected: selectedMarketId === marketId,
          selectedOptionId: selectedMarketId === marketId ? languageId : "",
          title: name,
          options: languages,
          onSelect: language => onSetMarket({
            market: searchResults[marketId],
            language
          }),
          dropdownLabel: intl.formatMessage({
            id: "account.market_settings_modal.select_language"
          })
        }, id);
      })]
    }), _Text3 || (_Text3 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text4.default, {
      size: "normal",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.market_settings_modal.global"
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "tb:max-w-[50%]",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownTile.default, {
        global: true,
        selected: isGlobalMarketSelected,
        selectedOptionId: isGlobalMarketSelected ? languageId : "",
        title: "Global",
        options: markets.xx.languages,
        dropdownLabel: intl.formatMessage({
          id: "account.market_settings_modal.select_language"
        }),
        onSelect: language => onSetMarket({
          market: markets.xx,
          language
        })
      })
    })]
  });
};
var _default = exports.default = LanguageSelect;